import { httpClient } from "../../../shared/api";

function cleanQuery(params = {}) {
  const out = {};
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    out[k] = v;
  });
  return out;
}

export const presalesApi = {
  getStats: () => httpClient.get("/presales/stats"),

  getLeads: (params = {}) =>
    httpClient.get("/presales/leads", { query: cleanQuery(params) }),

  getLead: (id) => httpClient.get(`/presales/leads/${id}`),

  createLead: (body) => httpClient.post("/presales/leads", body),

  updateLead: (id, body) => httpClient.patch(`/presales/leads/${id}`, body),

  deleteLead: (id) => httpClient.delete(`/presales/leads/${id}`),

  setStage: (id, stage) =>
    httpClient.patch(`/presales/leads/${id}/stage`, { stage }),

  upsertPricing: (id, body) => httpClient.put(`/presales/leads/${id}/pricing`, body),

  addNegEntry: (id, body) =>
    httpClient.post(`/presales/leads/${id}/negotiation`, body),

  deleteNegEntry: (entryId) =>
    httpClient.delete(`/presales/negotiation/${entryId}`),

  addReminder: (id, body) =>
    httpClient.post(`/presales/leads/${id}/reminders`, body),

  patchReminder: (reminderId, body) =>
    httpClient.patch(`/presales/reminders/${reminderId}`, body),

  deleteReminder: (reminderId) =>
    httpClient.delete(`/presales/reminders/${reminderId}`),

  addSpend: (id, body) =>
    httpClient.post(`/presales/leads/${id}/spend`, body),

  deleteSpend: (spendId) =>
    httpClient.delete(`/presales/spend/${spendId}`),

  getSow: (id) => httpClient.get(`/presales/leads/${id}/sow`),

  addSowProduct: (id, body) =>
    httpClient.post(`/presales/leads/${id}/sow/products`, body),

  deleteSowProduct: (sowProductId) =>
    httpClient.delete(`/presales/sow/products/${sowProductId}`),

  addSowModule: (sowProductId, body) =>
    httpClient.post(`/presales/sow/products/${sowProductId}/modules`, body),

  patchSowModule: (moduleId, body) =>
    httpClient.patch(`/presales/sow/modules/${moduleId}`, body),

  deleteSowModule: (moduleId) =>
    httpClient.delete(`/presales/sow/modules/${moduleId}`),

  addMilestone: (id, body) =>
    httpClient.post(`/presales/leads/${id}/milestones`, body),

  patchMilestone: (milestoneId, body) =>
    httpClient.patch(`/presales/milestones/${milestoneId}`, body),

  deleteMilestone: (milestoneId) =>
    httpClient.delete(`/presales/milestones/${milestoneId}`),

  listUsers: () => httpClient.get("/users/dropdown"),
  listProducts: () => httpClient.get("/products"),
  listFeatures: () => httpClient.get("/features"),
};
